import { useMemo } from "react";
import { CardEvent } from "features/shared/OpenedCardEvents/types";
import { RailSearchCardModel } from "entities/RailSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";

import { createEvents } from "../utils";

export const useOpenedCardEvents = (
  model?: Nullable<RailSearchCardModel>
): {
  hasEventEntries: boolean;
  eventEntries: CardEvent[];
} => {
  return useMemo(() => {
    const eventEntries = createEvents(model?.getTransformedEvents(model.events) ?? []);
    return {
      hasEventEntries: !!(
        eventEntries.length &&
        eventEntries[0].subEvents.dateList.length &&
        eventEntries[0].subEvents.descriptionList.length
      ),
      eventEntries,
    };
  }, [model?.rawData]);
};
